import clsx from 'clsx';
import type { OffertePackage } from '../../lib/offertes';
import type { PackageSku } from '../../lib/offerte-constants';
import { formatCurrency } from '../../lib/format';

interface Props {
  packages: OffertePackage[];
  selectedSku: PackageSku;
  onSelect: (sku: PackageSku) => void;
}

export function PackageChoice({ packages, selectedSku, onSelect }: Props) {
  if (!packages.length) {
    return (
      <div className="px-3 py-2.5 bg-slate-50 border border-slate-200 rounded-md text-xs text-slate-500">
        Geen pakketten beschikbaar.
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      <label className="text-xs font-medium text-slate-600 block">Pakket</label>
      <div className="space-y-2">
        {packages.map((pkg) => {
          const isSelected = pkg.sku === selectedSku;
          return (
            <label
              key={pkg.sku}
              className={clsx(
                'flex items-start gap-3 px-3 py-2.5 border rounded-md cursor-pointer transition-colors',
                isSelected
                  ? 'border-indigo-500 bg-indigo-50'
                  : 'border-slate-200 hover:border-slate-300 bg-white'
              )}
            >
              <input
                type="radio"
                name="offerte-package"
                className="mt-1 accent-indigo-600"
                checked={isSelected}
                onChange={() => onSelect(pkg.sku as PackageSku)}
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-slate-900">{pkg.label}</span>
                  {pkg.isPopular && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-amber-100 text-amber-700 font-medium">
                      Populair
                    </span>
                  )}
                </div>
                {pkg.priceDifference > 0 && (
                  <div className="text-xs text-slate-500 mt-0.5">
                    +{formatCurrency(pkg.priceDifference)} t.o.v. basis
                  </div>
                )}
              </div>
              <div className="text-sm font-semibold text-slate-900 flex-shrink-0">
                {formatCurrency(pkg.priceInclBtw)}
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}
